import { flagFactory } from '../icon';
import Svg from './lu.svg';

export default flagFactory(Svg);
